import { Component, OnInit, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-invoicing-component',
  templateUrl: './invoicing.component.html',
  styleUrls: ['./invoicing.component.scss']
})
export class InvoicingComponent implements OnInit {

  @ViewChild(RouterOutlet) outlet: RouterOutlet;


  constructor() { }

  ngOnInit(): void {
  }

}
